import getWorkshop from "./getWorkshop";
import {TIME_INPUT_TYPE_HOURS_DECIMAL, TIME_INPUT_TYPE_MINUTES_INTEGER} from "./workshopTimeInputTypes";

export default (quantityTime, forceMinutes = false, fixed = null) => {
  quantityTime = parseFloat(quantityTime);
  const timeInputType = getWorkshop().settings.timeInputType;

  if(timeInputType === TIME_INPUT_TYPE_MINUTES_INTEGER || forceMinutes){
    let minutes = parseInt((quantityTime * 60).toFixed(0));
    let ret = [];

    const isBelowZero = minutes < 0;
    if(isBelowZero){
      minutes *= (-1)
    }

    if(minutes > 0){
      let hour = Math.floor(minutes / 60);

      if(hour >= 1){
        minutes = minutes - (hour * 60);
      }

      if(hour >= 1){
        ret.push(hour + 'h');
      }
      if(minutes >= 1){
        ret.push(minutes + 'min');
      }
    }else{
      ret.push('0');
    }

    return (isBelowZero ? '-' : '') + ret.join(' ');
  }else if(timeInputType === TIME_INPUT_TYPE_HOURS_DECIMAL){
    let value = quantityTime
      .toFixed(fixed ? fixed : 5)
      .replace(/0+$/, '')

    const valueSplit = value.split('.');
    if(!valueSplit[1] || valueSplit[1].length < 2){
      value = parseFloat(value).toFixed(2);
    }

    return value + 'h';
  }
}
